@if (isReturnFailed) {
  @if (sorryMsg | async; as item) {
    <section class="col-xs-12 col-md-12 mt-5" id="retrunserror">
      <div class="thankorder_box">
        <div class="returnsorry_text" [innerHtml]="item.content"></div>
      </div>
    </section>
  }
}